import { useState } from "react";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";

// Vistas
import VentasReservasView from "./VentasReservas/VentasReservasView";
import GastosRentabilidadView from "./GastosRentabilidad/GastosRentabilidadView";
import OtrasMetricasView from "./OtrasMetricas/OtrasMetricasView";

// Tipos
export type TabId = 'ventas-reservas' | 'gastos-rentabilidad' | 'otras-metricas';

const TABS = [
  {
    id: 'ventas-reservas' as TabId,
    label: 'Ventas y Reservas',
    component: VentasReservasView
  },
  {
    id: 'gastos-rentabilidad' as TabId,
    label: 'Gastos y Rentabilidad',
    component: GastosRentabilidadView
  },
  {
    id: 'otras-metricas' as TabId,
    label: 'Otras métricas',
    component: OtrasMetricasView
  }
];

export default function Reportes() {
  const [activeTab, setActiveTab] = useState<TabId>('ventas-reservas');
  
  const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component || VentasReservasView;

  return (
    <div>
      <div className="mb-6">
        <PageBreadcrumb pageTitle="Reportes" />
      </div>
      
      <PageMeta
        title="Reportes y Estadísticas | Destiny Caribbean Tours"
        description="Sistema de reportes y análisis estadísticos"
      />
      
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-4 py-6 dark:border-gray-700 dark:bg-gray-800 sm:px-6 lg:px-8">

        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
            Reportes y estadísticas
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Consulte informes detallados sobre ventas, gastos y métricas clave de negocio
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="mb-8 overflow-x-auto">
          <nav className="flex flex-wrap sm:flex-nowrap border-b border-gray-200 dark:border-gray-700">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as TabId)}
                className={`
                  px-2 sm:px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap
                  flex-grow sm:flex-grow-0
                  ${activeTab === tab.id
                    ? 'border-brand-500 text-brand-600 dark:text-brand-400'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}
                `}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Active View */}
        <ActiveComponent />
      </div>
    </div>
  );
}